import React from 'react';
import { Box, SxProps } from '@mui/material';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';

export default function SectionWidgetFooter({
  children,
  sx,
}: {
  children: React.ReactNode;
  sx?: SxProps;
}) {
  const { isLessLaptop } = useBooleanScreens();
  return (
    <Box
      sx={{
        display: 'flex',
        height: '32px',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flex: '1 0 auto',
        gap: isLessLaptop ? '6px' : '4px',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
